import React from 'react';

const InformationInput = ({
	label,
	children,
	margin = false,
	isGrid = false,
	error = false,
}) => {
	return (
		<div
			className={`information-input is-align-items-center ${
				margin ? 'mb-4 mt-2' : ''
			}
			${isGrid ? 'is-grid' : 'is-flex'}`}>
			<span className="has-text-weight-bold pr-4">{label}:</span>
			<span>{children}</span>
			{error && (
				<i className="fz fz-exclamation-triangle solid has-text-danger is-flex" />
			)}
		</div>
	);
};

export default InformationInput;
